import React, { ReactElement } from 'react'
import Aetna from '@/components/InsuranceLogos/Aetna'
import Anthem from '@/components/InsuranceLogos/Anthem'
import Carousel from '@/components/molecules/Carousel/Carousel'
import Humana from '@/components/InsuranceLogos/Humana'
import UnitedHealthcare from '@/components/InsuranceLogos/UnitedHealthcare'
import Medicaid from '@/components/InsuranceLogos/Medicaid'
import { Department, getDepartmentText } from '@/domain/department'

export const insurances = [
  {
    subtitle: 'Treatment Covered By United',
    color: 'bg-[#EBF1FF]',
    link: '/insurance/united-healthcare/',
    logo: <UnitedHealthcare className="mx-auto w-32 text-[#002677]" />
  },
  {
    subtitle: 'Treatment Covered By Aetna',
    color: 'bg-[#FAEFFF]',
    link: '/insurance/aetna/',
    logo: <Aetna className="mx-auto w-32 text-[#7D3F98]" />
  },
  {
    subtitle: 'Treatment Covered By Anthem',
    color: 'bg-[#E7F2FF]',
    link: '/insurance/bluecross-blueshield/',
    logo: <Anthem className="mx-auto w-32 text-[#1355E9]" />
  },
  {
    subtitle: 'Treatment Covered By Humana',
    color: 'bg-[#EFFFDF]',
    link: '/insurance/humana/',
    logo: <Humana className="mx-auto w-32 text-[#4E8416]" />
  },
  {
    subtitle: 'Treatment Covered By Medicaid',
    color: 'bg-[#E9ECFF]',
    link: '/insurance/medicaid/',
    logo: <Medicaid className="mx-auto w-32 text-[#001489]" />
  }
]

const DEPARTMENT_TEXT = {
  [Department.Default]: {
    header: 'Choose Your Insurance',
    subtitle: 'Insurance covers addiction and mental health treatment.',
    viewAllLabel: 'All Insurance Providers'
  },
  [Department.Providers]: {
    header: 'Insurance Coverage'
  }
}

const InsuranceCarousel = ({
  department = Department.Default
}): ReactElement => {
  const { header, subtitle, viewAllLabel } = getDepartmentText({
    textValues: DEPARTMENT_TEXT,
    department
  })

  return (
    <Carousel
      title={header}
      subtitle={subtitle}
      items={insurances}
      viewAllLink="/insurance/"
      viewAllLabel={viewAllLabel}
    />
  )
}

export default InsuranceCarousel
